import React from "react";
import Collapsible from "react-collapsible";
// import { domain, headers, contentUrl } from '../../Variables'
import Loader from 'react-loader-spinner'
import HttpServices from "../../utils/Http.services";
import { checkTranslation, getObject, imageAddress, translate } from "../../utils/useful";
import FixedView from "../FixedView";
// import { lngTranslations } from "../../utils/useful";
// import { transform } from "lodash";
// import SelectWithSearch from "./SelectWithSearch";
// import { imageAddress } from "../../utils/useful";



class AdvancedMultiTreeSelect extends React.Component {

    state = {
        selected: '',
        subCheckCount: [],
        subCheck: [],
        isOpen: false,
        data: [],
        title: '',
        tempData: [],
        options: [],
        mainParents: [],
        mainParentsShow: [],
        isLoading: true,
        choosen: null,
        openRow: {},
        row: {},
        view: false

    }

    // toggleOpen = (makeOpen) => {

    //     let final = makeOpen != null ? makeOpen : !this.state.isOpen
    //     if (final != this.state.isOpen) {
    //         if (!this.state.isOpen) {
    //             document.addEventListener('mousedown', this.closeBox);
    //         } else {
    //             document.removeEventListener('mousedown', this.closeBox);
    //         }
    //     }
    //     // if (this.refs.icon)
    //     //     this.refs.icon.classList.toggle("rotate-180")


    //     this.setState({ isOpen: final, data: this.props.data }, () => {
    //         this.changePositionOnOpen()

    //     })

    // }


    toggleOpen = (open) => {
        let openState = open != null ? open : !this.state.isOpen
        if (openState) {

            this.fixedView.showView()

        } else {

            this.fixedView.hideView()


        }


        // this.refs.icon.classList.toggle("rotate-180")

        this.setState({ isOpen: openState, data: this.props.data })

    }


    closeOptions() {

        document.removeEventListener('mousedown', this.closeBox);
        if (this.refs.icon)
            this.refs.icon.classList.toggle("rotate-180")

        this.setState({ isOpen: false, data: this.props.data })
    }



    changeItem = (prop) => {
        this.setState({ choosen: prop, isOpen: false })
        // this.closeOptions()
        if (this.state.tempData.length > 0) {
            this.setState({ options: this.state.tempData })
        }
        let parent = prop.parent?._id
        let parents = [prop.value]
        // console.log('proplsls', prop)
        let parentValue = prop.mainParent
        this.getParent(parent, parents, () => {
            this.props.changeValue(this.props.header.key, prop.value, this.props.extra)
            setTimeout(() => {
                // console.log('this.props.header.secondKey', this.props.header.secondKey, parentValue)
                this.props.changeValue(this.props.header.secondKey, parentValue, this.props.extra)
            }, 10);
            this.toggleOpen(false)
        })
    }


    getParent(parent, parents, cb) {

        if (parent == null) {
            parents = []
            cb()
        } else {
            let found = false

            let tempData = this.state.tempData
            if (tempData.length == 0) {
                tempData = this.state.options
            }
            tempData.forEach(element => {


                if (element._id == parent) {
                    found = true
                    parents.splice(0, 0, element?._id)

                    if (element.parent == null) {
                        cb()
                    } else {
                        this.getParent(element.parent?._id, parents, cb)
                    }
                }

            });

            if (found == false) {
                cb()
            }

        }
    }

    setDefault() {
        if (this.props.data && this.props.data.title) {
            this.setState({ choosen: null })
            this.state.options.forEach(option => {
                let data = this.props.data?._id ?? this.props.data
                if (option.value == data) {
                    this.setState({ choosen: option }, () => {
                        this.countCalculator()
                    })
                    // this.props.changeValue(this.props.header.key, this.props.data.title, option.withOperator, option.flexible)
                    return
                }
            });



        }
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }


    componentDidMount() {
        // if(this.props.title){
        //     this.setState({value:this.props.title})
        // }
        this.init()
        // this.setState({ view: true })

        // window.addEventListener('scroll', this.changePositionOnOpen, true);
        // window.addEventListener('resize', this.changePositionOnOpen, true);

        // this.changePositionOnOpen()

        // setTimeout(() => {
        // }, 10);
    }

    componentDidUpdate(prevProp) {
        if (this.props.title != prevProp.title) {
            this.init()
        }
    }

    init() {
        if (this.props.header.information) {
            if (this.props.header.information.type == "local") {
                this.setState({ options: this.props.header.information.items }, () => {
                    this.countCalculator()
                })
            } else if (this.props.header.information.type == "api") {
                this.fetch()
                // this.setState({data:[]})
            }
        }
    }


    fetch() {
        this.setState({ isLoading: true })
        let mainParents = this.state.mainParents
        // let parentBody = this.props.header.information.body ?? {}
        // let body = this.props.header.information.body ?? {}
        // parentBody.filter = this.props.header.information.parentFilter
        let body = this.props.header.information.filter
        if (this.props.header.information.select) {
            body.select = this.props.header.information.select
        }
        if (this.props.header.information.sort) {
            body.sort = this.props.header.information.sort
        }
        for (const [key, value] of Object.entries(body)) {
            if (/\{\{(.*?)\}\}/.test(value)) {

                let baseValue = value.replace(/{/g, '').replace(/}/g, '')
                if (getObject(this.props.fullData, baseValue)) {
                    body[key] = getObject(this.props.fullData, baseValue)

                } else if (this.props.variables) {
                    body[key] = this.props.variables[baseValue]
                }
                // console.log("VAR")
            }
        }

        // console.log(body)
        // HttpServices.request(this.props.header.information.parentAddress, parentBody, (mainParents, fetchError) => {
        HttpServices.request(this.props.header.information.address, body, (data, fetchError) => {

            // console.log(data)

            this.setState({ isLoading: false })
            if (fetchError) {
                this.setState({ fetchError })
                return
            }

            let newData = []
            let choosen

            // console.log('data.infodata.info', data.info)
            // for (let i = 0; i < mainParents.info.length; i++) {
            //     const standard = mainParents.info[i];

            data.info.forEach(element => {
                let newTitle
                let newValue
                let newParent
                let mainParent
                let isMain = false
                if (this.props.header.information.fields.mainParent) {
                    mainParent = getObject(element, this.props.header.information.fields.mainParent)
                    if (!mainParent && !element[this.props.header.information.fields.parent] || element[this.props.header.information.fields.parent]?.length == 0) {
                        isMain = true
                    }
                    // if (mainParents.length > 0 && mainParents.includes(mainParent)) {

                    //     }
                    // else {
                    //     mainParents.push(mainParent)
                    // }
                }

                let myData = {}


                if (this.props.header.information.fields) {
                    for (const [key, value] of Object.entries(this.props.header.information.fields)) {

                        myData[key] = getObject(element, value)

                    }
                }

                // if (this.props.header.information.fields.value) {
                //     newValue = getObject(element, this.props.header.information.fields.value)
                // }
                // if (this.props.header.information.fields.parent) {
                //     newParent = getObject(element, this.props.header.information.fields.parent)
                // }
                // if (this.props.header.information.fields?.title) {
                //     newTitle = getObject(element, this.props.header.information.fields?.title)
                // }
                // let newImage = null
                // if (this.props.header.information.fields.image) {
                //     newImage = getObject(element, this.props.header.information.fields.image)
                // }


                // myData.type = getObject(element, 'type')
                myData.mainParent = mainParent
                myData.isMain = isMain
                myData._id = element._id

                // newData.push(this.props.data)
                newData.push(myData)




                if (this.props.data && myData.value == this.props.data) {
                    choosen = myData
                }


                // let type = getObject(element, 'type')

                // newData.push({ value: newValue, title: newTitle, image: newImage, parent: newParent, _id: element._id, mainParent: mainParent, isMain, type })
            });
            // }
            this.setState({
                options: newData,
                tempData: newData,
                mainParents: mainParents?.info,
                mainParentsShow: mainParents?.info,
                choosen,
                isLoading: false
            }, () => {
                this.setDefault()
            })
        })
        // })
    }


    spliter(source, string) {
        var stringArray = string.split('.')
        var finalString = source
        stringArray.forEach(element => {
            finalString = finalString[element]
        });
        return finalString
    }


    conditionalSettings(param, condition) {
        if (this.props.settings) {
            if (this.props.settings[param] == condition) {
                return true
            }
        }
        return false
    }


    search = async (value) => {

        this.toggleOpen(true)

        let options = this.state.tempData


        if (value == "") {
            await this.setState({ mainParentsShow: this.state.mainParents, options: this.state.tempData, searchOptions: null })
            await this.setState({ tempData: [], isSearching: false })
        } else {
            if (this.state.tempData.length == 0) {
                await this.setState({ tempData: this.state.options })
                options = this.state.options
            }
            var values = []
            // let options = this.state.tempData
            // var values = this.props.data.filter((e) => e.title === value)
            options.forEach(element => {
                if (element?.title.toLowerCase().includes(value.toLowerCase()) || (translate(element, 'title') && translate(element, 'title').toLowerCase().includes(value.toLowerCase()))) {

                    let found = false

                    options.forEach(child => {
                        if (child.parent?._id == element._id) {

                            found = true
                        }
                    });

                    if (found == false) {
                        values.push(element)
                    }
                }
            })
            let mainParents = []
            for (let x = 0; x < this.state.mainParents.length; x++) {
                const parent = this.state.mainParents[x];

                for (let i = 0; i < values.length; i++) {
                    const child = values[i];
                    if (child.mainParent == parent._id) {
                        if (!mainParents.includes(parent)) {
                            mainParents.push(parent)
                        }
                    }

                }
            }
            this.setState({ mainParentsShow: mainParents, options: values, isSearching: true })
            this.setState({ searchOptions: values })

            // }
        }
    }





    componentWillUnmount() {

        // this.window.removeEventListener('scroll', this.changePositionOnOpen, true);
        // this.window.removeEventListener('resize', this.changePositionOnOpen, true);

        if (this.unlisten)
            this.unlisten();
    }



    // setWrapperRef(node) {
    //     this.wrapperRef = node;
    // }



    changePositionOnOpen = () => {
        if (this.currentNode) {
            let bounds = this.currentNode.getBoundingClientRect()


            // if (this.refs.box) {
            //     let boxBounds = this.refs.box.getBoundingClientRect()



            this.setState({ width: bounds.width }, () => { })
            // }
        }
    }


    conditionalSettings(param, condition) {
        if (this.props.settings) {
            if (this.props.settings[param] == condition) {
                return true
            }
        }
        return false
    }
    showSub(prop) {

        this.state.subCheck[prop._id] = !this.state.subCheck[prop._id] ?? true;
        this.setState({ subCheck: this.state.subCheck })
    }



    countCalculator() {

        // if (this.state.tempData.length > 0)
        //     this.setState({ options: this.state.tempData })


        for (let i in this.state.options) {
            let id = this.state.options[i]._id
            if ((typeof (this.state.subCheckCount[this.state.options[i]._id]) == 'number')) {
                break;
            }
            for (let j in this.state.options) {
                if (this.state.options[j].parent?._id == id) {
                    this.state.subCheckCount[id] = 1;
                    this.setState({ subCheckCount: this.state.subCheckCount });
                    break;

                }
            }
        }
    }

    liActive(id) {
        let l = [];
        l[id] = true;


        this.setState({ brandCheck: l });
    }

    selectedMnu(id) {

        // this.state.selected = [];
        // this.state.selected[id] = 1;
        this.setState({ selected: id })
    }

    openParent = () => {

    }
    modelNotListed = () => {
        this.props.modelNotListed()
    }
    setRow = (mainParent) => {
        let row = this.state.row
        if (!row[mainParent._id]) {
            row[mainParent._id] = true
        } else {

            row[mainParent._id] = false
        }
        this.setState({ row })
    }
    onHide = () => {
        this.setState({ isOpen: false })
    }
    loadMainParents = () => {
        // console.log('loadMainParents')
        return this.state.options.map((prop, index) => {
            if (!prop.mainParent) {
                return (
                    <div className="mb-2" key={index} style={{ paddingLeft: 0, marginTop: 0, marginBottom: 0, paddingTop: '0px' }}>
                        <div className="select-item-addlisting" key={index} style={{ backgroundColor: (this.state.selected == prop._id) ? '#FFF3DB' : 'transparent', alignItems: 'center', borderBottomColor: '#f2f4f6', borderBottomStyle: 'solid', borderBottomWidth: 0, borderTop: '1px solid #f2f4f6', borderRight: 0, paddingTop: '10px' }}>
                            <div className="d-flex" style={{ alignItems: 'center', justifyContent: 'space-between', paddingRight: 0 }}>
                                <div className="flexcb w-100" onClick={() => { this.setRow(prop) }} style={{ padding: '5px 5px 5px 10px', display: 'flex', gap: '5px', cursor: 'pointer', width: '90%', }}>
                                    <div className="flexc">
                                        <img className="mrd-2" src={imageAddress(prop.image, 'applet', 'thumb')} width='25px' />
                                        <div>
                                            <p className="d-flex flex-column text-semibold" style={{ margin: 0, color: this.state.subCheckCount[prop._id] ? '#202020' : '#101010', fontSize: 14, fontWeight: this.state.subCheckCount[prop._id], textAlign: 'start' }}>
                                                {checkTranslation(prop.title)}
                                            </p>
                                            <p className="text-smallest">{translate("Applet")}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Collapsible open={!this.state.row[prop._id]} transitionTime={100} >

                            {this.loadRow(prop._id, 20)}

                        </Collapsible >
                    </div>
                )
            }
        })

    }


    loadRow(parent, paddingLeft) {
        return this.state.options.map((prop, index) => {
            let letShow = false
            let hasChildren = false

            let mparent = prop.parent ? prop.parent[prop.parent.length - 1] : null
            let mainParent = prop.mainParent

            // console.log('mparent', mparent)
            // console.log('mainParent', mainParent)
            if ((this.state.searchOptions != null)) {
                letShow = true
            }

            if (mparent == '' || mparent == null) {
                let parents = this.state.options.filter((a) => { return ((String(a._id) == String(mparent))) })
                if (parents.length == 0) {
                    letShow = false
                }
            }
            if ((mparent == parent || (mainParent == parent && prop.isMain))) {
                letShow = true
            }

            // let children = this.state.options.filter((a) => { return ((String(a.parent) == String(prop._id))) })
            // if (children.length > 0) {
            //     hasChildren = true
            // }

            if (letShow) {
                return (
                    <div className="d-flex" key={index}>

                        <div className="d-flex flex-column" style={{ paddingLeft: paddingLeft, marginTop: 0, marginBottom: 0, paddingTop: '0px', }}>
                            <div style={{ borderLeft: '1px solid #eee', paddingTop: '10px', }}>
                                <div className="select-item-addlisting" key={index} style={{ backgroundColor: (this.state.selected == prop._id) ? '#FFF3DB' : 'transparent', alignItems: 'center', borderBottomColor: '#f2f4f6', borderBottomStyle: 'solid', borderBottomWidth: 0, borderTop: paddingLeft == 0 ? '1px solid #f2f4f6' : 'none', borderRight: 0, }}>
                                    <div className="d-flex" style={{ alignItems: 'center', justifyContent: 'space-between', paddingRight: (paddingLeft / 2) }}>

                                        <div style={{ height: '1px', backgroundColor: '#eee', width: '12px' }}>
                                        </div>

                                        <div className="flexc w-100" onClick={() => { this.changeItem(prop) }} style={{ padding: '0px 0px 0px 0px', display: 'flex', gap: '5px', cursor: 'pointer', width: '90%', }}>

                                            {prop.type == 'folder' && (
                                                <div className='flexcc '>
                                                    <img className="transition-all " src={'/assets/icons/folder (1).png'} height={16} />
                                                </div>
                                            )}

                                            <p className="d-flex flex-column text-semibold mld-1" style={{ color: this.state.subCheckCount[prop._id] ? '#202020' : '#101010', fontSize: 13, fontWeight: this.state.subCheckCount[prop._id], textAlign: 'start' }}>
                                                {checkTranslation(prop.title)}

                                            </p>

                                        </div>
                                    </div>
                                </div>
                                {(this.state.searchOptions == null) ? this.loadRow(prop._id, 12) : ''}

                                {/* {(hasChildren) && (
                                    <div className="flexc" style={{ paddingTop: 10, transform: 'translatey(2px)' }}>
                                        <div style={{ height: '1px', backgroundColor: '#eee', width: '5px' }}>

                                        </div>
                                        <div style={{ height: '5px', backgroundColor: '#eee', width: '1px' }}>

                                        </div>
                                    </div>
                                )} */}
                            </div>

                        </div>
                    </div>

                )
            }

        })
    }



    render() {
        return (
            <div className='w-100' style={{ paddingRight: 2, paddingTop: 2, position: 'relative' }} >
                {/* {this.countCalculator()} */}
                <div className="d-flex" ref={el => this.currentNode = el} onClick={() => this.toggleOpen(true)} style={{ cursor: 'pointer', alignItems: 'center', color: '#fff !important', paddingLeft: 10, height: 30, flex: 1, width: '100%', borderRadius: 10, borderStyle: 'none', fontSize: 13, padding: '0px' }}>
                    {/* {this.props.icon && (
                        <img className="ml-1 mr-1" src={this.props.icon} style={{ height: 25, objectFit: 'contain' }} />
                    )}
                    <input disabled={this.conditionalSettings('disabled', true)} value={this.state.value} placeholder={this.props.placeholder} onInput={event => { this.search(event.target.value); this.setState({ value: event.target.value }) }} className='mediumiransansfont ' defaultValue={this.state.title} style={{ color: '#323232', padding: 5, flex: 1, width: '100%', borderStyle: 'none', fontSize: 15, background: 'transparent' }} /> */}
                    <div className="h-100 flexc" style={{ position: 'absolute', top: 0 }}>
                        <label className={' mrd-1 mld-1 ' + (this.state.choosen ? '' : "placeholder")}>{this.state.choosen?.title ? checkTranslation(this.state.choosen?.title) : checkTranslation(this.props.header?.information?.placeholder)}</label>
                    </div>


                </div>
                {/* {this.state.view && ( */}
                <FixedView ref={el => this.fixedView = el} nodeRef={this.currentNode} onHide={this.onHide} topOffset={5} bottomOffset={0} zIndex={80} xOffset={0} rightAlign={false} width={this.state.width}>

                    <div className="w-100" >
                        <div className={'w-100 m-0'} style={{ borderColor: '#eee', borderRadius: 6, maxHeight: 300, overflow: 'auto', backgroundColor: "#fff", borderRadius: 10, boxShadow: '0px 0px 30px rgba(0,0,0,0.1)', padding: '0px' }}>
                            <div className={'w-100 pb-3'} style={{ display: 'flex', flexDirection: 'column', position: 'relative' }}>
                                {/* {this.state.mainParentsShow.map((standardParent, i) => {
                                    return ( */}

                                {/* <div style={{ paddingLeft: 0, marginTop: 0, marginBottom: 0, paddingTop: '0px' }}>
                                    <div className="select-item-addlisting" key={i} style={{ backgroundColor: 'transparent', alignItems: 'center', borderBottomColor: '#f2f4f6', borderBottomStyle: 'solid', borderBottomWidth: 0, borderRight: 0, paddingBottom: '10px' }}>
                                        <div className="d-flex" style={{ alignItems: 'center', justifyContent: 'space-between', }}>
                                            <div className="flexcb w-100" onClick={() => { this.setRow(standardParent) }} style={{ padding: '5px 10px 5px 20px', display: 'flex', gap: '5px', cursor: 'pointer', width: '90%', }}>
                                                <p className="d-flex flex-column" style={{ margin: 0, color: '#101010', fontSize: 14, fontWeight: 'normal', textAlign: 'start' }}>
                                                    {standardParent.title}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    {this.state.openRow[standardParent._id] && (
                                        <>
                                        </>
                                        )}
                                    </div> */}
                                {this.state.isOpen ? (
                                    // <>
                                    this.loadMainParents()
                                    // </>
                                ) : ''}

                                {/* )

                                })} */}
                            </div>
                            {
                                this.state.options.length == 0 && !this.state.isLoading && (
                                    <div className="col-12">
                                        <p style={{ margin: 0, color: '#323232', opacity: 1, fontSize: 14, textAlign: 'center', backgroundColor: '#fff' }}>Found Nothing</p>
                                    </div>
                                )
                            }
                            {
                                this.state.isLoading && (
                                    <div className="flexcc py-3" style={{}}>
                                        <Loader
                                            type="Oval"
                                            color="rgb(255, 197, 0)"
                                            height="40"
                                            width="40"
                                        />
                                    </div>
                                )
                            }


                        </div>
                    </div>
                </FixedView>

                {/* )} */}
            </div>
        );
    }
}


export default AdvancedMultiTreeSelect;
